import { UI, Stack } from '@genial/components';
import { BoxRadius, Typography } from '@genial/design-tokens';
import React from 'react';

import { SubscriptionCustomerListItemProps } from '..';
import { HintButton } from '../../../../../../../components/HintButton';
import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { subscriptionCustomerListTableHead } from '../../SubscriptionCustomerListHeader/constants';

export const SubscriptionCustomerListItemDesktop: React.FC<SubscriptionCustomerListItemProps> = ({
  subscriptionCustomer,
  quantity,
  setQuantity,
  onSolicit,
  isDisabled,
  disabledMessage,
}) => {
  const getFlex = (index: number) => {
    const currentHead = subscriptionCustomerListTableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs" h="80px">
      <LateralBar
        backgroundColor="product.rendavariavel"
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <TableContentItemText>{subscriptionCustomer.customerNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{subscriptionCustomer.advisorNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{subscriptionCustomer.phoneNumberNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{subscriptionCustomer.emailNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText>{`${subscriptionCustomer.availableQuantity}`}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <Stack pr="inline.xxxs">
          <UI.InputStepper
            max={subscriptionCustomer.availableQuantity}
            min={1}
            name="quantity"
            defaultValue={quantity}
            onChange={setQuantity}
            stepperValue={1}
            disabled={isDisabled}
          />
        </Stack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <HintButton
          tooltip={disabledMessage}
          variant="textLink"
          isDisabled={isDisabled}
          _text={{
            color: 'brand.tertiary.principal',
            fontFamily: Typography['fontfamily.base.semibold'],
          }}
          onPress={onSolicit}
          rightIcon={<UI.Icon name="ChevronRight" size="xxxs" color="brand.tertiary.principal" />}>
          SOLICITAR
        </HintButton>
      </TableContentItemColumn>
    </TableContent>
  );
};
